import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {ProjectStatusWrapper, TopRow} from '../project_health_styles/ProjectStatus.styled';
import {StatusIndicator} from './StatusIndicator';
import Util from '../../../../forecast-app/shared/util/util';
import {Hexagon} from '@/web-components';

import {profilePicSrc} from '../../../../directApi';
import {RichTextEditorDraftJsWrapper} from '../../../../forecast-app/shared/components/rich-text-editor-draftjs-wrapper/RichTextEditorDraftJsWrapper';

const ProjectStatus = ({projectStatus, showStatusIndicator = true}) => {
	if (!projectStatus) return null;
	const creationDate = Util.CreateNonUtcMomentDate(projectStatus.year, projectStatus.month, projectStatus.day);

	return (
		<ProjectStatusWrapper>
			<TopRow>
				{showStatusIndicator ? <StatusIndicator projectStatusColor={projectStatus.color} /> : null}
				<Hexagon text={projectStatus.person.fullName} imgUrl={profilePicSrc(projectStatus.person.profilePictureId)} />
				<span style={{marginLeft: '4px'}}>
					{projectStatus.person.fullName + ' - ' + creationDate?.format(Util.GetShortYearMomentFormat('ll'))}
				</span>
			</TopRow>
			{projectStatus.description ? (
				<RichTextEditorDraftJsWrapper
					initialDraftJsContent={projectStatus.description}
					readOnly={true}
					id={projectStatus.id}
				/>
			) : null}
		</ProjectStatusWrapper>
	);
};

export default createFragmentContainer(ProjectStatus, {
	projectStatus: graphql`
		fragment ProjectStatus_projectStatus on ProjectStatus {
			id
			person {
				id
				fullName
				profilePictureId
				profilePictureDefaultId
			}
			description
			color
			day
			month
			year
		}
	`,
});
